// extracted by mini-css-extract-plugin
export default {"IconContainer":"MomentOfDelightIcon_IconContainer__ahALs","blink":"MomentOfDelightIcon_blink__L3DUc"};